const css = `._gridRow_13lbc_1 {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  width: 100%;
}

._gridColSpan_13lbc_8 {
  cursor: default;
}

._span-1_13lbc_12 {
  grid-column: span 1;
}

._span-2_13lbc_16 {
  grid-column: span 2;
}

._span-3_13lbc_20 {
  grid-column: span 3;
}

._span-4_13lbc_24 {
  grid-column: span 4;
}

._span-5_13lbc_28 {
  grid-column: span 5;
}

._span-6_13lbc_32 {
  grid-column: span 6;
}

._span-7_13lbc_36 {
  grid-column: span 7;
}

._span-8_13lbc_40 {
  grid-column: span 8;
}

._span-9_13lbc_44 {
  grid-column: span 9;
}

._span-10_13lbc_48 {
  grid-column: span 10;
}

._span-11_13lbc_52 {
  grid-column: span 11;
}

._span-12_13lbc_56 {
  grid-column: span 12;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "gridRow": "_gridRow_13lbc_1",
  "gridColSpan": "_gridColSpan_13lbc_8",
  "span-1": "_span-1_13lbc_12",
  "span-2": "_span-2_13lbc_16",
  "span-3": "_span-3_13lbc_20",
  "span-4": "_span-4_13lbc_24",
  "span-5": "_span-5_13lbc_28",
  "span-6": "_span-6_13lbc_32",
  "span-7": "_span-7_13lbc_36",
  "span-8": "_span-8_13lbc_40",
  "span-9": "_span-9_13lbc_44",
  "span-10": "_span-10_13lbc_48",
  "span-11": "_span-11_13lbc_52",
  "span-12": "_span-12_13lbc_56"
};